/**
 * Menu principal recolhido (rail só de ícones) — preferência POR USUÁRIO,
 * persistida no localStorage: quem recolhe o menu para ganhar área de trabalho o
 * encontra recolhido na próxima visita, em qualquer tela e depois de recarregar.
 *
 * Nos autos o menu nem aparece (`useMenuOculto`, docs/PLANO_BANCADA.md): o
 * escopo de rota que existia para eles (padrão recolhido só ali) saiu junto.
 */
import { useCallback, useMemo, useState } from 'react';

import {
  chaveDePreferencia,
  gravarPreferencia,
  lerPreferencia,
} from '@/lib/preferenciasUsuario';

import { useAuth } from './useAuth';

const STORAGE_PREFIX = 'jurisapp.sidebar.recolhido';

export function useSidebarRecolhido() {
  const { user } = useAuth();
  const chave = chaveDePreferencia(STORAGE_PREFIX, user?.id);

  // Escolha da sessão indexada PELA CHAVE: a identidade pode chegar depois do
  // primeiro render, e a escolha feita sem chave não vale para a conta que chega.
  const [escolhas, setEscolhas] = useState<Record<string, boolean>>({});

  const persistido = useMemo(() => {
    const cru = lerPreferencia(chave);
    return cru === null ? null : cru === '1';
  }, [chave]);

  const recolhido = (chave ? escolhas[chave] : undefined) ?? persistido ?? false;

  const setRecolhido = useCallback(
    (valor: boolean) => {
      if (chave) setEscolhas((anteriores) => ({ ...anteriores, [chave]: valor }));
      gravarPreferencia(chave, valor ? '1' : '0');
    },
    [chave],
  );

  return [recolhido, setRecolhido] as const;
}
